import React from 'react';
import cs from 'classnames';
import ToolTip from '~/components/common/ToolTip';
import css from './index.css';

const PremiumIcon = ({showToolTip}) => (
  <ToolTip
    trigger={<span className={cs(css.block, 'qa-premium-icon')}/>}
    visible={showToolTip}
  >
    <div className={css.tipContent}> Premium Loads are normally available only on paid sites but are offered FREE on Trucker Path</div>
  </ToolTip>
);

export default PremiumIcon;



// WEBPACK FOOTER //
// ./src/components/search/results/PremiumIcon/index.js